import { useMutation } from "react-query";
import {
  ClosedVehiclePremiumRequestParams,
  correctLastVehiclePremium,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const correctLastVehiclePremiumFn = async ({
  rowVersion,
  params,
}: {
  rowVersion: string;
  params: ClosedVehiclePremiumRequestParams;
}) => {
  return await correctLastVehiclePremium(rowVersion, params);
};

export function useCorrectLastVehiclePremium() {
  return useMutation(correctLastVehiclePremiumFn, {
    mutationKey: MUTATION_KEYS.correctLastVehiclePremium,
    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
